exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".YouTooText-module__YouTooText___2mEli{height:400px;display:flex;justify-content:center}@media (max-width:1000px){.YouTooText-module__YouTooText___2mEli{height:100px}.YouTooText-module__YouTooText___2mEli .YouTooText-module__text-wrapper___2WepW{display:none}}.YouTooText-module__YouTooText___2mEli .YouTooText-module__text-wrapper___2WepW{cursor:pointer;max-width:660px}.YouTooText-module__YouTooText___2mEli .YouTooText-module__text-wrapper___2WepW h1{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;color:#fff;font-size:200px;line-height:.95;font-weight:600;pointer-events:none}.YouTooText-module__YouTooText___2mEli .YouTooText-module__text-wrapper___2WepW .YouTooText-module__padding-left___29AOp{padding-left:148px}", ""]);

// exports
exports.locals = {
	"YouTooText": "YouTooText-module__YouTooText___2mEli",
	"text-wrapper": "YouTooText-module__text-wrapper___2WepW",
	"padding-left": "YouTooText-module__padding-left___29AOp"
};